module.exports = __webpack_public_path__ + "img/logo-text-en-armitaj.bf2697c.png";